<template>
	<FormInput
		ref="input"
		type="text"
		:value="value"
		@keydown="onZipKeydown"
		@input="onZipInput"
		:id="id"
		:placeholder="placeholder"
		:label="label"
		:labelOption="labelOption"
		:name="name"
		:icon="icon"
		v-bind="zipAttributes"
		:error="error"
		:hint="hint"
		:errorMessage="errorMessage"
		:success="success"
		:successMessage="successMessage"
		:required="required"
		:disabled="disabled"
	/>
</template>

<script>
import FormInput from '@/components/FormInput';

export default {
	components: {
		FormInput
	},
	props: {
		id: String,
		name: String,
		value: Number | String,
		placeholder: String,
		required: Boolean,
		disabled: Boolean,
		readonly: Boolean,
		label: String,
		labelOption: String,
		icon: String,
		hint: String,
		error: Boolean,
		errorMessage: String,
		success: Boolean,
		successMessage: String,
	},
	data() {
		return {
			zipAttributes: this.themeValue('THEME_ZIP_ATTRIBUTES') || {},
			zipNegRegex: new RegExp(`[^${this.themeValue('THEME_ZIP_ALLOWED_CHARS') || ''}]`, 'ig'),
		}
	},
	computed: {
	},
	model: {
		prop: 'value',
		event: 'input'
	},
	methods: {
		onZipKeydown(e) {
			if (!e.metaKey && !e.ctrlKey && e.key != null && e.key.length <= 1 && this.zipNegRegex.test(e.key)) {
				e.preventDefault()
			}
		},
		onZipInput(value) {
			if (value.match(this.zipNegRegex)) {
				value = value.replace(this.zipNegRegex, '');
				this.$refs.input.$refs.input.value = value;
			}
			this.$emit('input', value);
		},
	}
}
</script>

<style>

</style>
